module.exports = __webpack_public_path__ + "static/assets/4e19cc442fd34d5446b2db7beff53d6f.png";